export function getRenewalReturnPath(search = '') {
    const target = new URLSearchParams(search).get('returnTo');
    return /^\/verify-payment\?reference=[A-Za-z0-9_-]{1,200}$/.test(target || '') ? target : null;
}
